import { API_CALLS } from "@/services/apis/index.js";

export default {
  getBrandsWH(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.getWHBrandsAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getSeasonsWH(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.getWHSeasonsAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createBrand(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.createBrandAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createWHSeason(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.createWHSeasonAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetcWHCategories() {
    return new Promise((resolve, reject) => {
      API_CALLS.getWHCategories()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createWHCategory(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.createWHCategories(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateWHCategory(context , data) {
    return new Promise((resolve, reject) => {
      API_CALLS.updateWHCategory(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateWHBrand(context,data) {
    return new Promise((resolve, reject) => {
      API_CALLS.updateWHBrandAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateWHSeason(context,data) {
    return new Promise((resolve, reject) => {
      API_CALLS.updateWHSeasonAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getWHGender() {
    return new Promise((resolve, reject) => {
      API_CALLS.getWHGender()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateWHGender(context,data) {
    return new Promise((resolve, reject) => {
      API_CALLS.updateWHGenderAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createWHGender(context,data) {
    return new Promise((resolve, reject) => {
      API_CALLS.createWHGenderAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createWHColor(context,data) {
    return new Promise((resolve, reject) => {
      API_CALLS.createWHColorAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateWHColor(context,data) {
    return new Promise((resolve, reject) => {
      API_CALLS.updateWHColorAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getWHColors(context,data) {
    return new Promise((resolve, reject) => {
      API_CALLS.getWHColorAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


  getWHLanguage() {
    return new Promise((resolve, reject) => {
      API_CALLS.getWHLanguage()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateWHLanguage(context,data) {
    return new Promise((resolve, reject) => {
      API_CALLS.updateWHLanguageAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  createWHLanguage(context,data) {
    return new Promise((resolve, reject) => {
      API_CALLS.createWHLanguageAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};





